import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";
declare var $: any;

@Component({
  selector: 'app-texas',
  templateUrl: './texas.component.html',
  styleUrls: ['./texas.component.css']
})
export class TexasComponent implements OnInit {

  public windowwidth:number;
  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Texas - SFI Compliance, Inc");
    this.windowwidth=$(window).width();
    this.topposition();    
  }

  //scroll to top of the page automatically
  topposition() { 
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
}

}
